import { get } from 'lodash';
import { format } from 'date-fns';
import { createSelector } from 'reselect';
import transformServiceId from '../helpers/transformServiceId';
import { getPrice, getServiceProperty, getVoucher } from '../helpers';

export const locationSelector = state => get(state, 'router.location');
export const serviceSelector = (_, { service }) => service;
export const expiredSelector = (_, { expired }) => expired;
export const idSelector = createSelector(serviceSelector, ({ defaultSubscriptionInfo: { subscriptionId } }) => transformServiceId(subscriptionId));
export const serviceIdSelector = ({ subscriptions }) => {
  const serviceId = subscriptions.getIn(['selectedOption', 'id'])
      || subscriptions.getIn(['selected', 'id'])
      || subscriptions.getIn(['selectedOption', 'defaultSubscriptionInfo', 'subscriptionId']);

  return transformServiceId(serviceId);
};
export const subscriptionsSelector = state => get(state, 'userServices.data.subscriptions', []);
export const subscriptionsOptionsSelector = state => state.subscriptions.options;
export const subscriptionSelected = state => state.subscriptions.selected;

export const getActiveSubscription = createSelector(
  subscriptionsSelector,
  serviceInformation =>
    serviceInformation.find(service =>
      service
        .accountSubscriptionInfo.recurringPaymentInfo
        .statusInfo.statusDescription === 'Active'),
);

export const getLastExpiredSubscription = createSelector(
  subscriptionsSelector,
  serviceInformation =>
    serviceInformation.sort((prevSubscription, nextSubscription) => (
      new Date(nextSubscription.expiryDate)
            - new Date(prevSubscription.expiryDate)))[0],
);

export const getCurrentSubscription = createSelector(
  getActiveSubscription,
  getLastExpiredSubscription,
  (activeSubscription, lastExpiredSubscription) =>
    activeSubscription || lastExpiredSubscription,
);

export const getServicePriceId = createSelector(
  serviceIdSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('priceId'),
);

export const getServicePeriod = createSelector(
  serviceIdSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('periodUnit'),
);

export const getCurrentServicePeriod = createSelector(
  idSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('periodUnit'),
);

export const getServicePrice = createSelector(
  serviceIdSelector,
  subscriptionsOptionsSelector,
  getPrice,
);

export const getSubscriptionVoucher = createSelector(
  serviceIdSelector,
  subscriptionSelected,
  getVoucher,
);

export const getCurrentServicePrice = createSelector(
  idSelector,
  subscriptionsOptionsSelector,
  getPrice,
);

export const getServiceTitle = createSelector(
  serviceIdSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('title'),
);

export const getCurrentServiceTitle = createSelector(
  idSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('title'),
);

export const getCurrentServiceFeatures = createSelector(
  idSelector,
  subscriptionsOptionsSelector,
  getServiceProperty('features'),
);

export const getServicePayment = createSelector(
  getCurrentSubscription,
  (service) => {
    const nextPaymentDate = get(service, 'accountSubscriptionInfo.expiryDate', '');
    const date = new Date(nextPaymentDate);
    const dateFormat = 'Do MMMM YYYY';

    return format(date, dateFormat);
  },
);

export const getCurrentServicePayment = createSelector(
  serviceSelector,
  expiredSelector,
  ({ accountSubscriptionInfo: { expiryDate } }, expired) => {
    const PAYMENT_EXPIRED = 'Expired';

    if (expired) {
      return PAYMENT_EXPIRED;
    }

    const date = new Date(expiryDate);
    const dateFormat = 'Do MMMM YYYY';

    return format(date, dateFormat);
  },
);
